import { render, staticRenderFns } from "./addCoupon.vue?vue&type=template&id=5388695f&scoped=true&"
import script from "./addCoupon.vue?vue&type=script&lang=js&"
export * from "./addCoupon.vue?vue&type=script&lang=js&"
import style0 from "./addCoupon.vue?vue&type=style&index=0&id=5388695f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5388695f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5388695f')) {
      api.createRecord('5388695f', component.options)
    } else {
      api.reload('5388695f', component.options)
    }
    module.hot.accept("./addCoupon.vue?vue&type=template&id=5388695f&scoped=true&", function () {
      api.rerender('5388695f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/couponMarketplace/components/addCoupon.vue"
export default component.exports